import { createFileRoute, redirect } from '@tanstack/react-router'

// The chat settings are on the Assistant page, next to the test chat.
export const Route = createFileRoute('/_auth/_main/websites/$siteId/settings/chat')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/websites/$siteId/settings',
            params,
            replace: true,
        })
    },
})
